import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@chapche/ui';

const DownloadCsvButton = ({ labelKey, onExport, className = 'product__button' }) => {
    const { i18n } = useTranslation();
    const [exporting, setExporting] = useState(false);

    const handleClick = () => {
        if (exporting) {
            return;
        }
        setExporting(true);
        onExport(() => setExporting(false));
    };

    return (
        <Button
            type="button"
            variant="outline"
            className={className}
            onClick={handleClick}
            disabled={exporting}
        >
            {exporting ? i18n.t('app.page.product.exportingCSV') : i18n.t(labelKey)}
        </Button>
    );
};

export default DownloadCsvButton;
